// extracted by mini-css-extract-plugin
export default {"mpd-list-loader-animated":"FormSectionTitle_mpd-list-loader-animated__MRP6K","placeHolderShimmer":"FormSectionTitle_placeHolderShimmer__NT-JO","root":"FormSectionTitle_root__gX9EO"};